import { render, staticRenderFns } from "./PartnerContacts.vue?vue&type=template&id=9383540c"
import script from "./PartnerContacts.vue?vue&type=script&lang=js"
export * from "./PartnerContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports